import { FeatureFlagLabels } from "@src/lib/FeatureFlags";
import { useAxios } from "@src/lib/http";
import { useQuery } from "@tanstack/react-query";

export const useTenantFeatureFlags = (tenancyId?: number) => {
  const { instance, isEnabled } = useAxios("TENANT_API");

  return useQuery({
    queryKey: ["features-flags-tenant", tenancyId],
    queryFn: async () => {
      const response = await instance.get(`/features/${tenancyId}/${FeatureFlagLabels.OwnerTenant}`);
      return response.data;
    },
    enabled: isEnabled && !!tenancyId
  });
};
